import { Input } from '../../device-api/input';
import { CTV_KEY } from '../../utils/ctv-input';
const KEY_CODE_MAP = {
    [CTV_KEY.UP]: [38],
    [CTV_KEY.DOWN]: [40],
    [CTV_KEY.LEFT]: [37],
    [CTV_KEY.RIGHT]: [39],
    [CTV_KEY.ENTER]: [13],
    [CTV_KEY.BACK]: [27],
    [CTV_KEY.DELETE]: [8],
    [CTV_KEY.FF]: [33],
    [CTV_KEY.RW]: [34],
    [CTV_KEY.PLAY]: [32],
    [CTV_KEY.PAUSE]: [80],
    [CTV_KEY.STOP]: [83],
    [CTV_KEY.RED]: [82],
    [CTV_KEY.GREEN]: [71],
    [CTV_KEY.YELLOW]: [66],
    [CTV_KEY.BLUE]: [89],
    [CTV_KEY.INFO]: [73],
    [CTV_KEY.AD]: [112],
    [CTV_KEY.SEARCH]: [113],
    [CTV_KEY.SUBTITLES]: [114],
    [CTV_KEY.HELP]: [115],
    [CTV_KEY.SKIP_PREV]: [118],
    [CTV_KEY.SKIP_NEXT]: [120],
    [CTV_KEY[1]]: [49],
    [CTV_KEY[2]]: [50],
    [CTV_KEY[3]]: [51],
    [CTV_KEY[4]]: [52],
    [CTV_KEY[5]]: [53],
    [CTV_KEY[6]]: [54],
    [CTV_KEY[7]]: [55],
    [CTV_KEY[8]]: [56],
    [CTV_KEY[9]]: [57],
    [CTV_KEY[0]]: [48],
    [CTV_KEY.SHORTCUT_9]: [32],
};
const PREVENT_DEFAULT = new Set();
export class BrowserInput extends Input {
    // @override
    keyCodeMap = KEY_CODE_MAP;
    preventDefault = PREVENT_DEFAULT;
}
//# sourceMappingURL=browser-input.js.map